import React from "react";

export const CustomExportCSVButton = onClick => (
  <button
    type="button"
    className="mt-3 mb-3 btn btn-info btn-sm btn-download"
    onClick={e => {
      onClick();
      e.preventDefault();
    }}
  >
    <i className="fa fa-download" aria-hidden="true"></i> Export to Excel
  </button>
);

// Helper function to add credit rows on export
export const addCreditsOnExportToCSV = (rows, year) => e => {
  const colNames = Object.keys(rows[0]);
  // getCreditRow: function adds credit row (as json) to the data rows
  // making sure that credit is in the first column and all remaining
  // columns are empty
  const getCreditRow = credit =>
    colNames.reduce(
      (creditRow, col, i) =>
        i === 0 ? { [col]: credit } : { ...creditRow, [col]: "" },
      {}
    );
  const companyContact = "Geografia Pty Ltd. Contact: info@geografia.com.au";
  const downloadDate = new Date().toISOString().split("T")[0];

  return rows.concat([
    getCreditRow(`Source: ABS Census Data ${year}`),
    getCreditRow(`Compiled by: ${companyContact}`),
    getCreditRow(`Downloaded on: ${downloadDate}`)
  ]);
};



// WEBPACK FOOTER //
// ./components/Tables/Common.js